export default __webpack_public_path__ + "static/Isometric-grid-dark-9896c474a2755d7fcd83cb4dd5d021a1.png";